import { billOfMaterialsTemplateBindingIdFormat } from "@redotech/redo-fulfillment-id";
import { BomTemplateBindingSpec } from "@redotech/redo-inventory-common/bill-of-materials/bom-template-spec";
import * as z from "zod";

export const updateBomTemplateBinding = {
  name: "updateBomTemplateBinding" as const,
  input: z.object({
    bindingId: billOfMaterialsTemplateBindingIdFormat.schema,
    spec: BomTemplateBindingSpec,
  }),
  output: z.object({}),
};
